module.exports = __webpack_public_path__ + "img/rights-content.53cd8670.png";